// Drop-in replacement for echarts-for-react, so that number and time-label
// formatting is decided once instead of in 66 chart files.
//
// The charts import this under the same local name they used before
// (`ReactEChartsCore` / `ReactECharts`), so nothing else in them changes. What
// it adds is a pass over the option object — see utils/chartFormat.js — which
// fills in the formatters a chart did not define and leaves the ones it did.
//
// forwardRef is not optional here: several charts keep a `chartRef` and reach
// for getEchartsInstance() through it. A plain function component would swallow
// the ref and leave those refs null.

import { forwardRef } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import ReactEChartsFull from 'echarts-for-react';
import { applyChartFormatting } from './utils/chartFormat';

const EChartCore = forwardRef(({ option, ...rest }, ref) => (
  <ReactEChartsCore ref={ref} option={applyChartFormatting(option)} {...rest} />
));
EChartCore.displayName = 'EChartCore';

/** For the handful of charts importing the full bundle rather than core. */
export const EChart = forwardRef(({ option, ...rest }, ref) => (
  <ReactEChartsFull ref={ref} option={applyChartFormatting(option)} {...rest} />
));
EChart.displayName = 'EChart';

export default EChartCore;
